import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import CustomChip from '../../../components/CustomChip.vue';
import CardMaisFiltros from './CardMaisFiltros.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { OPERADORES } from '@/constants/operadores';
import { onMounted } from 'vue';

interface IOperador {
  operador: string;
  tooltip: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardParametrosConsulta',
  setup(__props) {

const store = ConsultaObrasStore();

const { filtroObras, flProducaoCientifica } = storeToRefs(store);
const { consultaObras, limparTodosFiltroBoletins } = store;

onMounted(async () => {
  flProducaoCientifica.value = await store.getFlProducaoCientifica();
});

const handleClickTermos = (termo: IOperador) => {
  let dePesquisa = filtroObras.value.dePesquisaTermos;

  const { operador } = termo;

  switch (operador) {
    case 'Aspas':
      dePesquisa = dePesquisa ? '"' + dePesquisa + '"' : '""';
      break;
    case 'Interrogacao':
      dePesquisa = dePesquisa ? dePesquisa + '?' : '?';
      break;
    case 'Asterisco':
      dePesquisa = dePesquisa ? dePesquisa + '*' : '*';
      break;
    default:
      dePesquisa = dePesquisa ? `${dePesquisa} ${operador} ` : operador;
  }

  filtroObras.value = {
    ...filtroObras.value,
    dePesquisaTermos: dePesquisa,
  };
};

return { __sfc: true,store, filtroObras, flProducaoCientifica, consultaObras, limparTodosFiltroBoletins, handleClickTermos, CustomChip, CardMaisFiltros, OPERADORES }
}

})